import { render, staticRenderFns } from "./PopUpGetBrouillon.vue?vue&type=template&id=7d4af06d&scoped=true"
import script from "./PopUpGetBrouillon.vue?vue&type=script&lang=js"
export * from "./PopUpGetBrouillon.vue?vue&type=script&lang=js"
import style0 from "./PopUpGetBrouillon.vue?vue&type=style&index=0&id=7d4af06d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4af06d",
  null
  
)

export default component.exports